<app-page-content [showProgress]="assigning">
  <span pagetitle>Tildel sendinger</span>

  <div pagecontent style="margin-bottom: 4em">
    <mat-form-field style="width: 100%; margin-top: 0.5em" floatLabel="always">
      <mat-label>Bærer</mat-label>
      <mat-select [(value)]="carrier">
        <mat-option value="">Alle bærere</mat-option>
        <mat-option *ngFor="let route of carriers" [value]="route.Id">{{ route.Name }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <app-button-box pagefooter>
    <button mat-raised-button color="warn" (click)="cancel()">AVBRYT</button>
    <button style="margin-right: 0.5em" mat-raised-button color="primary" (click)="assign()">TILDEL</button>
  </app-button-box>
</app-page-content>
